'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Theme = undefined;
exports['default'] = createTheme;

var _animations = require('./animations');

var _animations2 = _interopRequireDefault(_animations);

var _breakpoints = require('./breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _mixins = require('./mixins');

var _mixins2 = _interopRequireDefault(_mixins);

var _palette = require('./palette');

var _palette2 = _interopRequireDefault(_palette);

var _shadows = require('./shadows');

var _shadows2 = _interopRequireDefault(_shadows);

var _transitions = require('./transitions');

var _transitions2 = _interopRequireDefault(_transitions);

var _typography = require('./typography');

var _typography2 = _interopRequireDefault(_typography);

var _variables = require('./variables');

var _variables2 = _interopRequireDefault(_variables);

var _zIndex = require('./zIndex');

var _zIndex2 = _interopRequireDefault(_zIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Theme = exports.Theme = function () {
  function Theme() {
    _classCallCheck(this, Theme);
  }

  return Theme;
}();

function createTheme() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _config$breakpoints = config.breakpoints,
      breakpoints = _config$breakpoints === undefined ? (0, _breakpoints2['default'])() : _config$breakpoints,
      _config$palette = config.palette,
      palette = _config$palette === undefined ? (0, _palette2['default'])() : _config$palette,
      _config$typography = config.typography,
      typography = _config$typography === undefined ? (0, _typography2['default'])(palette) : _config$typography,
      _config$mixins = config.mixins,
      mixins = _config$mixins === undefined ? (0, _mixins2['default'])(breakpoints, palette, typography, _variables2['default']) : _config$mixins,
      options = _objectWithoutProperties(config, ['breakpoints', 'palette', 'typography', 'mixins']);

  var theme = Object.assign({
    animations: _animations2['default'],
    breakpoints: breakpoints,
    dir: 'ltr',
    mixins: mixins,
    palette: palette,
    shadows: _shadows2['default'],
    spacing: { unit: _typography.STEP },
    transitions: _transitions2['default'],
    typography: typography,
    variables: _variables2['default'],
    zIndex: _zIndex2['default']
  }, options);

  Object.setPrototypeOf(theme, new Theme());

  return theme;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/styles/theme.js
// module id = 336
// module chunks = 32